import React, { useEffect,useState } from "react";
import { Modal,Button} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { WarningOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { CheckCircleOutlined } from "@ant-design/icons";

import "./qsetdashboardevalcard.scss";


function QSETDashboardEvalCard({evalItem,questionsArray}) {

    const qsetUserDetails = JSON.parse(localStorage.getItem("qsetUserDetails"));
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    const handleTsToDate = (value) => {
        const eDay = new Date(value*1000);
        return eDay.toDateString()
    };
    const handleTsToTime = (value) => {
        const eDay = new Date(value*1000);
        return eDay.toLocaleTimeString()
    };
    const handleOnClick = () =>{
      navigate(`/qsethome/qsetjd`)
    }

  const handleStartTest = () => {
    var ev_id = evalItem.qhevid;
    navigate(`/qsethome/qset/prestart/${ev_id}`);
  };

  const EvalStatus = {
    Pending: (
      <>
        <Button
          className="apply-button"
          disabled={evalItem.status === "Completed"}
          onClick={handleStartTest}
        >
          Start Test
        </Button>
        <span className="company-name">
          <span className=" eval-expires">Expires On:</span>

          {handleTsToDate(evalItem.expirydatets)}

          {handleTsToTime(evalItem.expirydatets)}
        </span>
      </>
    ),
    "Proctoring Fail": (
      <>
        <div className="result-info-warning">
          <span className="info-warning">
            <WarningOutlined />
          </span>{" "}
          Proctoring terminated after repeated violations.
        </div>
        <p className="contact-info">Please contact HR for more information.</p>
      </>
    ),

    Completed: (
      <>
        <div className="result-info-completed">
          <span className="info-completed">
            <CheckCircleOutlined />
          </span>{" "}
          Awaiting Results... HR will get back to you for next steps
        </div>
        {/* <p className="contact-info">HR will contact you soon.</p> */}
      </>
    ),
  };

  return (
    <div className="qset-eval-card">
      <div className="eval-card-header">
        <div className="eval-title">{evalItem.name}</div>
        <div className="eval-title1" onClick={handleOnClick}>
          {" "}
          View JD
        </div>
      </div>
      <div className="eval-duration">
        <ClockCircleOutlined /> {evalItem.duration} mins
      </div>
      <div className="eval-details">
        {evalItem.skills?.map((skill, idx) => (
          <span className="eval-detail-item eval-skill">
            {skill.toUpperCase()}
          </span>
        ))}
      </div>
      {EvalStatus[evalItem.status]}
    </div>
  );
}

export default QSETDashboardEvalCard;
